

import React, { useContext } from "react"
import { QuoteContextStore } from '../../context/QuoteContext/QuoteContext';
import * as yup from 'yup';
import { FormControlLabel, Grid, Radio, RadioGroup } from "@material-ui/core"
import AirportCodeForm from "./AirportSections/AirportCodeForm"
import AirportDetailsForm from "./AirportSections/AirportDetailsForm"
import {LoadingContextStore} from "../../context/LoadingContext/LoadingContext";
import { SessionContextStore } from "../../context/SessionContext/SessionContext";
import { useParams } from "react-router-dom";


export const airportSchema = yup
.object()
  .shape({
    code: yup.string(),
    name: yup.string().nullable().required("Required"),
    city: yup.string().nullable().required("Required"),
    state: yup.string().required("Required").test("state", "Required", (state) => state !== 'default'),
    airport_not_found: yup.boolean(),
    runway_length: yup.number("Required").typeError('Required').required("Required").test("runway_length", "Required", (runway_length) => runway_length > 0),
    runway_surface: yup.string().required("Required").test("runway_surface", "Required", (runway_surface) => runway_surface !== 'default'),
    runway_elevation: yup.number("Required").typeError('Required').required("Required"),
})
.required();

export const AirportStep = () => {
    const { quoteId } = useParams()
    const { awaitWithLoading } = useContext(LoadingContextStore);
    const { finishAirport, airportSearchMode, changeAirportMode ,locked_quote} = useContext(QuoteContextStore)

    const onSubmit = async (data) => {
        await awaitWithLoading(finishAirport({ ...data, quote_id: quoteId }));
    }

    const handleChangeMode = (e) => {
        const { value } = e.target;
        changeAirportMode(value);
    }

    const renderSections = () => {
        switch (airportSearchMode) {
            case "code":
                return <AirportCodeForm submit={onSubmit}/>
            case "details":
                return <AirportDetailsForm submit={onSubmit}/>
            default:
                break;
        }
    }

    return (
        <React.Fragment>
            <div className="margin-top-medium">
                    <Grid container className="margin-bottom-large" direction="column">
                        <RadioGroup value={airportSearchMode} onChange={handleChangeMode}>
                            <Grid container>
                                <FormControlLabel
                                value="code"
                                control={<Radio color="primary" />}
                                disabled={locked_quote}
                                label={<span className={`${airportSearchMode === "code" ? "bolder" : ""} blue`} >Search by airport code</span>}
                                />
                                <FormControlLabel
                                value="details"
                                control={<Radio color="primary" />}
                                disabled={locked_quote}
                                label={<span className={`${airportSearchMode === "details" ? "bolder" : ""} blue`}>Search by airport details</span>}
                                />
                            </Grid>
                        </RadioGroup>
                    </Grid>
                    {renderSections()}
            </div>
        </React.Fragment>
    )
}

export default AirportStep;